export const COMPONENT_TOKEN_PREFIX = "--sds--";
